module.exports = __webpack_public_path__ + "media/images/it/icons/instagram-6c3986404dc323b6b6a76e5a2aaf7e32.svg";